import { Injectable } from '@angular/core';
import {Http,Response,Headers,RequestOptions} from "@angular/http";
import {Post} from "../models/post.model";
import {server,days,post_create,post_get_one,post_get_All_by_user, post_update_one,post_delete_one,post_get_by_area,
        post_get_by_area_and_days} from "./index.path";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import {LocalDataService} from "../services/local-data.service";


@Injectable()
export class PublicationsService {

  url_create = server.concat(post_create);
  url_post_get_All_by_user = server+post_get_All_by_user;
  url_post_update_one = server + post_update_one;
  url_post_delete_one = server + post_delete_one;
  url_post_get_by_area = server +post_get_by_area;
  url_post_get_by_area_and_days_before = server + post_get_by_area_and_days;
  publication:FormData;

  constructor(private http:Http,private _localDS:LocalDataService) {
   }

  createPublication(post:Post){
    // console.log("PublicationsService: createPublication");
    if(post.file)this.fileToBase64(post);
    this.buildFormData(post);
    // console.log(post);
     return this.http.post(this.url_create,this.publication)
                    .map((res: any) => {
                      return res.json();
                    }).catch((err: Response) => {
                      let error = err.json();
                      // console.log("fallo servicio createPublication: "+error.message);
                      alert("algo salio mal! verifica que  los campos no esten vacios y la informacion sea correcta");
                      post=null;
                      return Observable.throw(error)
                    })
  }

  getPublications(){
    // console.log("PublicationsService: getPublications");
      let credentials = this._localDS.credentials;
      return this.http.get(this.url_post_get_All_by_user+String(credentials.userMR.user.id)+"/posts")
                      .map((res: any) => {
                          // console.log(res.json());
                          return res.json();
                      }).catch((err: Response) => {
                        let error = err.json();
                        // console.log("fallo servicio getPublication: "+error.message);
                        return Observable.throw(error)
      })


  }

  editPublication(id_post:number,title:string,comment:string){
    // console.log("PublicationsService: editPublication");
    let credentials = this._localDS.credentials;
    let headers = new Headers({ 'Accept': 'application/json', 'Authorization': 'Bearer '+credentials.userMR.auth_token});
    let options = new RequestOptions({ headers: headers });
    let urlfinal = this.url_post_update_one + String(id_post);
    let info = {
      "title": title,
      "comment": comment
    }
    return this.http.put(urlfinal, info, options)
                    .map((res: any) => {
                        // console.log(res.json());
                        return res.json();
                    }).catch((err: Response) => {
                        let error = err.json();
                        // console.log("fallo servicio editPublication: "+error.message);
                        return Observable.throw(error)
    })
  }

  deletePublication(idx: number){
    // console.log("PublicationsService: deletePublication "+idx);
    let credentials = this._localDS.credentials;
    let headers = new Headers({ 'Accept': 'application/json', 'Authorization': 'Bearer ' + credentials.userMR.auth_token });
    let options = new RequestOptions({ headers: headers });
    let urlfinal = this.url_post_delete_one + String(idx);
    return this.http.delete(urlfinal,options)
                    .map((res: any) => {
                      // console.log(res.json());
                      return res.json();
                    }).catch((err: Response) => {
                      let error = err.json();
                      // console.log("fallo servicio editPublication: "+error.message);
                      return Observable.throw(error)
                    })
  }

  getPublicationsbyLocation(lat:string,lng:string,radius:number){
    // console.log("PublicationsService: getPublicationsbyLocation ");
    let headers = new Headers({ 'Accept': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    let info = {
      "latitude": lat,
      "longitude": lng,
      "radius": radius,
    }
     return this.http.post(this.url_post_get_by_area, info,options)
                      .map((res: any) => {
                        // console.log(res.json());
                        return res.json();
                      }).catch((err: Response) => {
                        let error = err.json();
                        // console.log("fallo servicio getPublicationsbyLocation "+error.message);
                        return Observable.throw(error)
                      })
  }

  getPublicationsbyLocationAndFilters(lat:string,lng:string,radius:number,title?:string,
                                      date_event?:string,time_event?:string,username?:string){
    // console.log("PublicationsService: getPublicationsbyLocation ");
    let headers = new Headers({ 'Accept': 'application/json'});
    let options = new RequestOptions({ headers: headers });

    let url_final = this.url_post_get_by_area+"?latitude="+lat+"&longitude="+lng+"&radius="+radius;
    if(title||date_event||time_event||username){
      if(title)url_final = url_final+"&title="+title;
      if(date_event)url_final = url_final+"&date_event="+date_event;
      if(time_event)url_final = url_final+"&time_event="+time_event;
      if(username)url_final = url_final+"&username="+username;
    }
    // console.log("url_final");
    // console.log(url_final);
     return this.http.get(url_final,options)
                      .map((res: any) => {
                        // console.log(res.json());
                        return res.json();
                      }).catch((err: Response) => {
                        let error = err.json();
                        // console.log("fallo servicio getPublicationsbyLocation "+error.message);
                        return Observable.throw(error)
                      })
  }

  getPublicationsByLocationAndDays(lat:string,lng:string,radius:number){
    console.log("PublicationsProvider: getPublicationsByLocationAndDays ");
    let date = this.getCurrentDateAndDaysBefore().split(",",2);
    let headers = new Headers({ 'Accept': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    let url_final = this.url_post_get_by_area_and_days_before+"?latitude="+lat+"&longitude="+lng+"&radius="+radius+"&start_date="+
                    date[0]+"&end_date="+date[1];
    console.log("url_final: "+url_final);

    return this.http.get(url_final,options)
     .map((res: any) => {
       console.log(res.json());
       return res.json();
     }).catch((err: Response) => {
       let error = err.json();
       console.log("fallo servicio getPublicationsByLocationAndDays  " + error.message);
       alert("algo salio mal: "+JSON.stringify(error) + " intentalo de nuevo");
       return Observable.throw(error)
     })
  }

  getCurrentDateAndDaysBefore():string{
    let date = new Date();
    let day = Number(date.getDate());
    let month = Number(date.getMonth())+1;
    let year = Number(date.getFullYear());
    let dayBefore:number = day;
    let monthbefore:number = month;
    let yearbefore:number = year;
    let hour = date.getHours();
    let min = date.getMinutes();
    console.log("initial date: "+year+"-"+month+"-"+day+" "+hour+":"+min);


    for (let i = 0; i < 5; i++) {
      hour = hour+1;
      if(hour>23){
        hour=0;
        day=day+1;
        if(month==2){
          if(day>28){
            day=1;
            month=month+1;
          }
        }
        else if(month==1 || month==3 || month==5 || month==7 || month==8 || month==10 || month==12){//months end 31
          if(day>31){
            day=1;
            month=month+1;
          }
          if (month>12) {
            month = 1;
            year =year+1;
          }
        }
        else if(month==4 || month==6 || month==9 || month==11){
          if(day>30){
            day=1;
            month=month+1;
          }
        }
      }
    }
    console.log("updated date: "+year+"-"+month+"-"+day+" "+hour+":"+min);
    for (let i = 0; i < days; i++) {
      dayBefore = dayBefore-1;
      console.log("daysbefore: "+dayBefore);
      
      if(dayBefore<1){
        if(month==3){//its march
          dayBefore = 28;
          monthbefore = monthbefore-1;
        }
        else if(month==10 || month==7 || month==5){
          if(dayBefore<1){
            dayBefore=30;
            monthbefore=monthbefore-1;
          }
        }
        else if(month==2 || month==4 || month==6 || month==9 || month==8 || month==1 || month==11 || month==12){
          if(dayBefore<1){
            dayBefore=31;
            monthbefore=monthbefore-1;
          }
          if (month<0) {
            monthbefore = 12;
            yearbefore =yearbefore-1;
          }
        }
      }
    }
    console.log("construccion");
    
    let startday = yearbefore+"";
    console.log(startday);
    
    if(monthbefore<10) startday = startday+"-0"+monthbefore;
    else startday = startday+"-"+monthbefore;
    console.log(startday);
    if(dayBefore<10) startday = startday+"-0"+dayBefore;
    else startday = startday+"-"+dayBefore;
    console.log(startday);

    console.log("construccion");
    let finalday = year+"";
    if(month<10) finalday = finalday + "-0" + month;
    else finalday = finalday + "-" + month;
    console.log(startday);
    if(day<10) finalday = finalday + "-0" + day;
    else finalday = finalday + "-" + day;
    console.log(startday);

    console.log("start_date: "+startday);
    console.log("final_date: "+finalday);
    return startday+","+finalday;

  }

  private fileToBase64(post:Post){
    // console.log("file to base64");
    var reader = new FileReader();
    reader.readAsDataURL(post.fileraw);
    reader.onload = function () {
      post.file = reader.result;
      post.fileraw = null;
    };
    reader.onerror = function (error) {
    //  console.log('Error: ', error);
    };

  }

  private buildFormData(post:Post){
    this.publication = new FormData();
    if(post.user_id){
      this.publication.append("user_id",post.user_id);
    }else console.log("no hay userid");
    
    this.publication.append("title",post.title);
    this.publication.append("comment",post.comment);
    this.publication.append("latitude_publication",post.latitude_publication);
    this.publication.append("longitude_publication",post.longitude_publication);
    this.publication.append("latitude_event",post.latitude_event);
    this.publication.append("longitude_event",post.longitude_event);
    this.publication.append("datetime_event",post.datetime_event);
    this.publication.append("file",post.file);
    this.publication.append("private",post.private);
    this.publication.append("device_type",post.device_type);

  }



}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/services/publications.service.ts